import { AfterViewInit, Component, ContentChildren, ElementRef, EventEmitter, forwardRef, HostBinding, HostListener, Input, OnDestroy, OnInit, Output, QueryList } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PopoverController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { LanguageService } from 'src/app/service/language/language.service';
import { SelectOptionComponent } from '../select-option/select-option.component';
import { SelectPopoverComponent, SELECT_OPTION } from '../select-popover/select-popover.component';
const noop = () => {};

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectComponent),
    multi: true
  }]
})
export class SelectComponent implements ControlValueAccessor, OnInit, AfterViewInit, OnDestroy {

  @ContentChildren(SelectOptionComponent) options:QueryList<SelectOptionComponent>;
  optionsSubs:Subscription;

  @Input() label:string;
  @Input() placeholder = this.lang.selected.category.select;
  @Input() optionWidth;
  @Input() readonly:string | boolean = false; 
  @Input() disabled:boolean = false;
  @Input('multiple') multiple;
  @Input() optionValue:string = null;
  @Output() change = new EventEmitter();

  @HostBinding('class.disabled') get classDisabled() { return this.readonly }
  @HostListener('click', ["$event"]) onClick = (event) => {
    if(this.disabled) return;
    const opts:SELECT_OPTION[] = [];
    this.options.toArray()
    .map(opt => {
      opts.push({
        value: opt.value,
        text: opt.text.nativeElement.innerHTML,
        unique: opt.unique,
        hide: opt.hide
      });
    });
    this.popoverOptions(opts, {target: this.el.nativeElement});
  }

  text:string = '';

  constructor(
    private el: ElementRef,
    private popover: PopoverController,
    private lang: LanguageService
  ) {
    
  }
  ngOnInit() {
  }
  ngAfterViewInit() {
    this.optionsSubs = this.options.changes.subscribe(() => {
      this.getText();
    });
  }
  ngOnDestroy() {
    this.optionsSubs.unsubscribe();
  }
  getText() {
    if(this.options) {
      const multiple = (this.multiple !== false && this.multiple !== 'false' && this.multiple !== undefined);
      if(!multiple) {
        const opt = this.options.toArray().find(v => {
          if(typeof v.value === 'object') return JSON.stringify(v.value) === JSON.stringify(this.value);
          else return v.value === this.value;
        });
        if(opt) this.text = opt.text.nativeElement.innerText;
        else this.text = '';
      } else {
        const opts = this.options.toArray().filter(opt => {
          const equalItem = this.value.find(v => {
            if(typeof v === 'object') {
              if(this.optionValue) {
                return v[this.optionValue] === opt.value[this.optionValue];
              } else {
                return JSON.stringify(v) === JSON.stringify(opt.value);   
              }
            }
            else return v === opt.value;
          });
          return equalItem != null;
        });
        this.text = opts.map(opt => opt.text.nativeElement.innerText).join(',');
      }
      this.onChangeCallback(this.value);
      this.change.emit(this.value);
    }
  }

  async popoverOptions(opts, event) {
    const popoverOpts = opts.filter(x => !x.hide);
    const multiple = (this.multiple !== false && this.multiple !== 'false' && this.multiple !== undefined);
    const popover = await this.popover.create({
      cssClass: 'select-popover',
      component: SelectPopoverComponent,
      componentProps: {
        opts: popoverOpts,
        values: this.value,
        multiple
      },
      event,
      showBackdrop: false
    });

    await popover.present();

    const { data } = await popover.onWillDismiss();
    if(data) {
      if(multiple) {
        const values = [];
        const texts = [];
        data.map(item => {
          values.push(item.value);
          texts.push(item.text);
        });
        this.value = values;
        this.text = texts.join(',');
      } else {
        this.value = data.value;
        this.text = data.text.replace(/<[^>]*>/, '');
      }
    }
  }


  //기본 셋팅(엔간해선 건드릴 일은 없음)
  private innerValue:any = null;
  get value() { return this.innerValue; };
  @Input('value') set value(v) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.getText();
    }
  }
  writeValue(value: any) { 
    if (value !== this.innerValue) {
      this.innerValue = value;
      this.getText();
    }
  }
  //뭔지모르는 애들
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;
  registerOnChange(fn: any) { this.onChangeCallback = fn; }
  registerOnTouched(fn: any) { this.onTouchedCallback = fn; }
  onBlur() { this.onTouchedCallback(); }
}
